export default function Inicio() {
  return (
    <div className="min-h-screen bg-black p-6">
    </div>
  );
}
